import { AnyAction, createAsyncThunk, ThunkAction } from '@reduxjs/toolkit';
import type { AppDispatch, RootState } from './redux-store';

export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, AnyAction>;

export const createAppAsyncThunk = createAsyncThunk.withTypes<{ dispatch: AppDispatch, rejectValue: void, state: RootState }>();